import { connect } from 'react-redux';
import { expandAndFocusCommentPanel } from '../../../../DeviationPage/redux/actions';
const mapStateToProps = (state)=>({});
const mapDispatchToProps = {
    expandAndFocusCommentPanel
};
export default connect(mapStateToProps, mapDispatchToProps);
